import { render, staticRenderFns } from "./PrizeList.vue?vue&type=template&id=3ea377a2&scoped=true"
import script from "./PrizeList.vue?vue&type=script&lang=js"
export * from "./PrizeList.vue?vue&type=script&lang=js"
import style0 from "./PrizeList.vue?vue&type=style&index=0&id=3ea377a2&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/.store/vue-loader@15.11.1/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3ea377a2",
  null
  
)

export default component.exports